import { useState } from "react";
import { Icon } from "@juiceforward/narrative-player";

interface LoginPageProps {
  onLogin: () => void;
}

export const LoginPage = ({ onLogin }: LoginPageProps) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Mock authentication - accept any credentials
    setTimeout(() => {
      setIsLoading(false);
      onLogin();
    }, 800);
  };

  return (
    <div className="min-h-screen bg-fwd-navy flex items-center justify-center p-4 relative overflow-hidden">
      {/* Subtle background grid — matches hero */}
      <svg
        className="absolute inset-0 w-full h-full pointer-events-none opacity-[0.06]"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern
            id="loginGrid"
            x="0"
            y="0"
            width="24"
            height="24"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M 24 0 L 0 0 0 24"
              fill="none"
              stroke="white"
              strokeWidth="0.5"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#loginGrid)" />
      </svg>

      <div className="w-full max-w-md relative z-10">
        {/* Logo */}
        <div className="text-center mb-10">
          <div className="font-display text-4xl tracking-tight text-white mb-2">
            FORWARD
          </div>
          <p className="text-white/40 text-sm tracking-wide">Admin Dashboard</p>
        </div>

        {/* Login Card */}
        <div className="bg-white/[0.07] backdrop-blur-sm border border-white/10 rounded-lg p-8">
          <h2 className="text-2xl font-display text-white mb-6">Sign In</h2>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-white/50 mb-2">
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@forward.ai"
                required
                className="w-full bg-white/[0.06] border border-white/10 rounded px-4 py-2.5 text-white placeholder-white/25 focus:outline-none focus:border-fwd-red/60 transition-colors"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-white/50 mb-2">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                className="w-full bg-white/[0.06] border border-white/10 rounded px-4 py-2.5 text-white placeholder-white/25 focus:outline-none focus:border-fwd-red/60 transition-colors"
              />
            </div>
            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-fwd-red hover:opacity-90 disabled:opacity-50 text-white text-sm font-semibold tracking-wider uppercase py-3 rounded transition-opacity"
            >
              {isLoading ? (
                <>
                  <Icon icon="spinner" className="mr-2 animate-spin" />
                  Signing in...
                </>
              ) : (
                <>
                  <Icon icon="right-to-bracket" className="mr-2" />
                  Sign In
                </>
              )}
            </button>
          </form>

          <div className="mt-6 text-center text-sm">
            <a
              href="#"
              className="text-white/35 hover:text-fwd-yellow transition-colors"
            >
              Forgot password?
            </a>
          </div>
        </div>

        {/* Back to Home Link */}
        <div className="text-center mt-8">
          <a
            href="/"
            className="text-sm text-white/40 hover:text-white transition-colors"
          >
            <Icon icon="arrow-left" className="mr-2" />
            Back to Home
          </a>
        </div>
      </div>
    </div>
  );
};
